
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta } from "/app/src/pages/index.vue?macro=true";
import { default as _91slug_93cQKMScLmoXntDfnMazv6_zctEnkFv5qWJdO_45cisR1coMeta } from "/app/src/pages/[slug].vue?macro=true";
import { default as indexLdI3469p2zXtz1RX__45UgO27aK9o_45Cpr87dcNzXCiLRYMeta } from "/app/src/pages/review/index.vue?macro=true";
import { default as index6tHTO9yyZ6W36lAgVCJDAwqZfZXxFDLQ6LwumzZ7mxkMeta } from "/app/src/pages/search/index.vue?macro=true";
import { default as _91slug_93tWB_vH3qr17fJ83XexdtMzukv0x0ZJlU_LwrjzuU0i4Meta } from "/app/src/pages/categories/[slug].vue?macro=true";
import { default as _91slug_93e1dspd60u9ygT2fhRmXjSNDqjiWK0J0dmKbYwI_dWBgMeta } from "/app/src/pages/collections/[slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/app/src/pages/[slug].vue")
  },
  {
    name: "review",
    path: "/review",
    meta: indexLdI3469p2zXtz1RX__45UgO27aK9o_45Cpr87dcNzXCiLRYMeta || {},
    component: () => import("/app/src/pages/review/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/app/src/pages/search/index.vue")
  },
  {
    name: "categories-slug",
    path: "/categories/:slug()",
    component: () => import("/app/src/pages/categories/[slug].vue")
  },
  {
    name: "collections-slug",
    path: "/collections/:slug()",
    component: () => import("/app/src/pages/collections/[slug].vue")
  }
]